/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/PersonMatches/Content/PersonMatch/Info/Details/Person/Name"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let personMatchValueData = fromData.useDataFormat({ viewPath,
context: 'person_match',
format: fromFormat.statusPersonName,
})
let constantData = ','
let aggregateData = fromAggregate.joinNoSpace(personMatchValueData, constantData)
let personMatchGender0ValueData = fromData.useDataValue({ viewPath,
context: 'person_match',
path: 'gender[0]',
})
let constantData1 = ','
let aggregateData1 = fromAggregate.joinNoSpace(personMatchGender0ValueData, constantData1)
let personMatchBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'person_match',
path: 'birth_date',
format: fromFormat.dateShortIn,
})
  return (<React.Fragment
>
<div
  data-testid="Name.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-aEsB': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="person_match"
 format="/Data/format.js statusPersonName"
 data="','"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="person_match.gender[0]"
 data="','"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData1}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="person_match.birth_date"
 format="/Data/format.js dateShortIn"
 text={personMatchBirthDateValueData}
/>
</div>
{children}
</React.Fragment>)
}